import {
  Future,
  Instrument
} from '@iv/model/instrument';
import { Type } from '@angular/core';
import { IChartDashboard } from '../charts-dashboard/state/dashboard';
import { ICard } from '../charts-dashboard/state/card';
import { IChartSeries } from 'app/charts-dashboard/state/series';

export class Tab  {
  constructor(
    public component: Type<any>,
    public data: ITabData,
    public id?: string,
    public type?: TabTypeEnum,
    public active?: boolean,
    public name?: string,
    public description?: string,
  ) {
  }
}

export enum TabTypeEnum {
  CHART_SERVICE = 'chartService',
  FUTURES_MONITOR = 'futuresMonitor',
  STOCK_MONITOR = 'service',
  OPTION_CHAIN = 'instrument',
  FUTURES_OPTION_CHAIN = 'future'
}

interface ITabData {
  instrument?: Instrument;
  chartType?: number;
  serviceTabs?: ServiceTab[];
  summaryLineVisibleColumns?: string[];
  selectedGroupId?: number;
  sorting?: Sorting;
  visibleColumns?: string[];
  screenerType?: string;
  termType?: any;
  tradeDatePeriod?: any;
  period?: any;
  percent?: any;
  future?: Future;
  hideCharts?: any;
  dashboard?: IChartDashboard<ICard<IChartSeries>>;
}

interface ServiceTab {
  active: boolean;
  id: number;
  component: string;
  name: string;
  filters: Filters;
  visibleColumns: string[];
}

interface Expirations {
  id: string;
  value: string;
  type: string;
}

interface FilterType {
  name: string;
  value: string;
}

interface Filters {
  expirations: Expirations;
  strikesN: string;
  type: FilterType;
  center: number;
  futExpDate?: any;
}

interface Sorting {
  symbol: string;
}

export interface TabComponent {
  id?: any;
  data?: any;
  symbolClickEvent?: any;
  onGroupsChanges?: any;
  instruments?: any;
  groups?: any;
  selectedCenter?: any;
}
